// extracted by mini-css-extract-plugin
module.exports = {"MainContent":"BasicLayout_MainContent__NUbQo"};